import { Tab, Tabs } from '@finn-no/troika-react-tabs';
import React, { useState } from 'react';
import SvgLogoAdressa from '~/components/logos/LogoAdressa';
import SvgLogoTek from '~/components/logos/LogoTek';
import Aftenposten from '../logos/LogoAp';
import BergensTidende from '../logos/LogoBt';
import E24 from '../logos/LogoE24';
import Facebook from '../logos/LogoFacebook';
import Fedrelandsvennen from '../logos/LogoFvn';
import StavangerAftenblad from '../logos/LogoSa';
import VG from '../logos/LogoVg';
import Open from './open';
import Preview from './preview';
import PreviewFacebook from './preview-facebook';
import type { PreviewConfig } from './config';

type Props = {
    config: PreviewConfig;
};

function PreviewTabs(props: Props) {
    const [index, setIndex] = useState<number>(0);

    const { config } = props;
    const { finnkode } = config;

    return (
        <Tabs defaultIndex={index} onChange={(i) => setIndex(i)}>
            <Tab title={<VG className="logo auto" role="img" aria-label="VG" />}>
                <Preview config={config} channel="vg.no" active={index === 0} />
                <Open finncode={finnkode} channel="vg.no" active={index === 0} />
            </Tab>
            <Tab title={<Aftenposten className="logo" role="img" aria-label="Aftenposten" />}>
                <Preview config={config} channel="ap.no" active={index === 1} />
                <Open finncode={finnkode} channel="ap.no" active={index === 1} />
            </Tab>
            <Tab title={<E24 className="logo" role="img" aria-label="E24" />}>
                <Preview config={config} channel="e24" active={index === 2} />
                <Open finncode={finnkode} channel="e24" active={index === 2} />
            </Tab>
            <Tab title={<Fedrelandsvennen className="logo" role="img" aria-label="Fædrelandsvennen" />}>
                <Preview config={config} channel="fvn.no" active={index === 3} />
                <Open finncode={finnkode} channel="fvn.no" active={index === 3} />
            </Tab>
            <Tab title={<StavangerAftenblad className="logo" role="img" aria-label="Stavanger Aftenblad" />}>
                <Preview config={config} channel="aftenbladet.no" active={index === 4} />
                <Open finncode={finnkode} channel="aftenbladet.no" active={index === 4} />
            </Tab>
            <Tab title={<BergensTidende className="logo" role="img" aria-label="Bergens Tidende" />}>
                <Preview config={config} channel="bt.no" active={index === 5} />
                <Open finncode={finnkode} channel="bt.no" active={index === 5} />
            </Tab>
            <Tab title={<SvgLogoTek role="img" aria-label="Tek" width={35} height={35} />}>
                <Preview config={config} channel="tek" active={index === 6} />
                <Open finncode={finnkode} channel="tek" active={index === 6} />
            </Tab>
            <Tab title={<Facebook className="logo" role="img" aria-label="Facebook" />}>
                <PreviewFacebook config={config} active={index === 7} />
            </Tab>
            <Tab title={<SvgLogoAdressa role="img" aria-label="Adressa" width={35} height={35} />}>
                <Preview config={config} channel="adressa.no" active={index === 8} />
                <Open finncode={finnkode} channel="adressa.no" active={index === 8} />
            </Tab>
        </Tabs>
    );
}

export default PreviewTabs;
